var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header fixed up priority-4 hide-768"},[_c('i',{staticClass:"icon icon--union"})])
}]

export { render, staticRenderFns }